import type { CustomerProfileResponseDto } from '../../api';
import type { CustomerProfile } from '../../types/sales.types';
import { formatPhoneNumber } from '../formatters/text';

export const SALES_ORDER_NO_CUSTOMER_LABEL = 'Sin cliente asociado';

export function getSalesOrderCustomerDisplayName(
  customer?: CustomerProfileResponseDto | CustomerProfile | null,
): string {
  const name = customer?.customerName?.trim();
  return name || SALES_ORDER_NO_CUSTOMER_LABEL;
}

export function hasSalesOrderCustomer(
  customer?: CustomerProfileResponseDto | CustomerProfile | null,
): boolean {
  return Boolean(customer?.customerName?.trim());
}

function getCustomerIdentityDocument(
  customer?: CustomerProfileResponseDto | CustomerProfile | null,
): string | null {
  if (customer == null || !('identityDocumentNumber' in customer)) {
    return null;
  }
  const doc = customer.identityDocumentNumber;
  if (typeof doc !== 'string') return null;
  const trimmed = doc.trim();
  return trimmed || null;
}

/** Nombre del cliente con CI/ID cuando hay cliente asociado. */
export function getSalesOrderCustomerDetailLabel(
  customer?: CustomerProfileResponseDto | CustomerProfile | null,
): string {
  if (!hasSalesOrderCustomer(customer)) {
    return SALES_ORDER_NO_CUSTOMER_LABEL;
  }
  const name = getSalesOrderCustomerDisplayName(customer);
  const identityDocument = getCustomerIdentityDocument(customer);
  if (identityDocument) {
    return `${name} · CI: ${identityDocument}`;
  }
  return `${name} · CI no registrada`;
}

/** Teléfono del cliente para detalle de venta; null si no hay cliente asociado. */
export function getSalesOrderCustomerPhoneDisplay(
  customer?: CustomerProfileResponseDto | CustomerProfile | null,
): { label: string; hasPhone: boolean } | null {
  if (!hasSalesOrderCustomer(customer)) {
    return null;
  }
  const phone = customer?.customerPhone?.trim();
  const hasPhone = phone != null && phone !== '';
  return {
    label: hasPhone ? formatPhoneNumber(phone) : 'No registrado',
    hasPhone,
  };
}
